import { Mapper } from 'src/base/mapper'
import { InvoicePDFTypeEntity } from 'src/data/entities/invoice.entity'
import { InvoicePDFTypeModel } from 'src/domain/models/invoice.model'

export class InvoicePDFMapper extends Mapper<InvoicePDFTypeEntity, InvoicePDFTypeModel> {
	mapFrom(param: InvoicePDFTypeEntity): InvoicePDFTypeModel {
		return {
			filename: param.filename,
			data: param.data,
			url: param.url,
		}
	}

	mapTo(param: InvoicePDFTypeModel): InvoicePDFTypeEntity {
		return {
			filename: param.filename,
			data: param.data,
			url: param.url,
		}
	}
}
